import styled, { css } from "styled-components";
import React, { Component } from "react";
import CalendarRange from "mdi-material-ui/CalendarRange";
import CloudSearch from "mdi-material-ui/CloudSearch";
import SortAlphabeticalVariant from "mdi-material-ui/SortAlphabeticalVariant";
import Update from "mdi-material-ui/Update";

import { _ } from "js/vendor";
import { SearchBar } from "js/react/views/AddSlide/Panes/Components/SearchBox";
import { FlexSpacer, Gap10, Gap20, Gap30 } from "js/react/components/Gap";
import { Fragment } from "react";
import { Icon, IconButton, MenuItem, Slider } from "@material-ui/core";
import { IconMenu } from "js/react/components/UiComponents";
import { themeColors } from "js/react/sharedStyles";
import { app } from "js/namespaces";
import { t } from "js/i18n";
import PresentationLibraryPaneController from "js/controllers/PresentationLibraryPaneController";

const StyledLibraryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  //flex-grow: 2;
  //padding-right: 30px;
  .material-icons {
    color: #11A9E2;
  }
`;

const StyledSearchBar = styled(SearchBar)`

    ${props => props.$isMobile && `
        padding: 0;
    `}
`;

const iconMenuStyles = css`
    &&& {
        padding: 0;
    }
`;

const StyledIconMenu = styled(IconMenu)`
    ${iconMenuStyles};
`;

const StyledIconButton = styled(IconButton)`
    ${iconMenuStyles};
`;
export const PresentationListHeader = PresentationLibraryPaneController.withState(class PresentationListHeader extends Component {
    constructor(props) {
        super();

        this.state = {
            thumbnailSize: props.thumbnailSize
        };

        this.searchBarRef = React.createRef();
    }

    get sortOptions() {
        return [{
            field: "document.name", label: t("Name"), direction: "asc", icon: <SortAlphabeticalVariant />
        }, {
            field: "document.createdAt", label: t("Recently Created"), direction: "desc", icon: <CalendarRange />
        }, {
            field: "document.modifiedAt", label: t("Recently Edited"), direction: "desc", icon: <Update />
        }];
    }

    handleSetSort = sort => {
        PresentationLibraryPaneController.setSort([{ field: sort.field, direction: sort.direction }]);
    }

    handleSearch = value => {
        PresentationLibraryPaneController.setSearch({ query: value });
    }

    toggleViewType = () => {
        const viewType = this.props.viewType == "grid" ? "list" : "grid";
        PresentationLibraryPaneController.setViewType(viewType);
    }

    handleShowSearchBar = () => {
        this.setState({ showSearchBar: true }, () => {
            this.searchBarRef.current?.focusInput();
        });
    }

    handleHideSearchBar = () => {
        this.setState({ showSearchBar: false });
    }

    render() {
        let { showSearchBar } = this.state;
        let { viewType = "grid", className = "", sort, search } = this.props;

        return (
            <StyledLibraryHeader className={className}>
                <IconButton size="small" onClick={this.handleShowSearchBar}
                    style={{ color: themeColors.ui_blue }}><Icon>search</Icon></IconButton>

                {(showSearchBar || app.isMobileOrTablet) &&
                    <Fragment>
                        <StyledSearchBar
                            ref={this.searchBarRef}
                            showIcon={false}
                            placeholder="Search presentations"
                            onSearch={this.handleSearch}
                            onBlurOnEmpty={this.handleHideSearchBar}
                            $isMobile={app.isMobileOrTablet}
                        />
                    </Fragment>
                }
                {
                    (viewType == "grid" || app.isConstrained) &&
                    <Fragment>
                        {
                            !app.isConstrained &&
                            <Gap20 />
                        }
                        {
                            !app.isMobileOrTablet &&
                            app.integrator &&
                            <Gap10 />
                        }
                        <StyledIconMenu icon="sort" $isMobile={app.isMobileOrTablet}>
                            {!search.query && this.sortOptions.map(option => (
                                <MenuItem
                                    key={option.field}
                                    selected={sort[0]?.field === option.field}
                                    onClick={() => this.handleSetSort(option)}>
                                    {option.icon && <Icon>{option.icon}</Icon>}
                                    {option.label}
                                </MenuItem>
                            ))}
                            {search.query &&
                                <MenuItem selected>
                                    <Icon><CloudSearch /></Icon>
                                    {t("Relevance")}
                                </MenuItem>
                            }
                        </StyledIconMenu>
                    </Fragment>
                }

                {
                    !app.isConstrained &&
                    <Fragment>
                        <Gap20 />
                        <StyledIconButton onClick={() => this.toggleViewType()}>
                            <Icon>{viewType == "grid" ? "view_module" : "view_list"}</Icon>
                        </StyledIconButton>
                    </Fragment>
                }
                {
                    app.isConstrained &&
                    <Fragment>
                        <StyledIconButton onClick={() => this.toggleViewType()} $isMobile={app.isMobileOrTablet}>
                            <Icon>{viewType == "grid" ? "view_module" : "view_list"}</Icon>
                        </StyledIconButton>
                    </Fragment>
                }
            </StyledLibraryHeader>
        );
    }
});
